$(".glossary .item .title").on("click", function () {
    $(this).toggleClass("active");
    if ($(this).hasClass("active")) {
        $(this).next().slideDown();
    } else {
        $(this).next().slideUp();
    }
});
if (false) {
    $(".glossary .glossary-letters .letter").on("click", function () {
        if ($(this).hasClass("-active")) return;
        let this_letter = $(this).data("symbol");

        $(".glossary .item .title.active").each(function () {
            $(this).removeClass("active");
            $(this).next().css("display", "none");
        });


        $(".glossary .glossary-letters .letter").removeClass("-active");
        $(this).addClass("-active");


        if (this_letter) {
            $(".glossary .items .item").hide();
            $(".glossary .items .item[data-letter='" + this_letter + "']").show();
        } else {
            $(".glossary .items .item").show();
        }


    });
}